/***********************
 GLOBAL MAP
************************/
  var settings = {
    show_sale_price: true , // Assuming we want to show the sale price by default
    discount1_from_price: 0,
    discount1_to_price: 0,
    discount1: 0.0,
    discount2_from_price: 0,
    discount2_to_price: 0,
    discount2: 0.0,
    discount3_from_price: 0,
    discount3_to_price: 0,
    discount3: 0.0,
    discount4_from_price: 0,
    discount4_to_price: 0,
    discount4: 0.0,
    discount5_from_price: 0,
    discount5_to_price: 0,
    discount5: 0.0,
    currency_format_enable: false,
  };
  
// let skuMap = {};


/***********************
 MAIN ENTRY POINT
************************/
document.addEventListener("DOMContentLoaded", async () => {
  const skuString = window.productSimilarSKUs;
   
  if (!skuString || skuString.trim() === "") {
    console.log("No Similar SKUs metafield found.");
    return;
  }

  // const similarSKUs = skuString.split(/\s+/).filter(Boolean);
let similarSKUs = [];

// ✅ handle string
if (typeof skuString === "string") {
  similarSKUs = skuString.split(/\s+/).filter(Boolean);
}

// ✅ handle array (YOUR CASE)
else if (Array.isArray(skuString)) {
  similarSKUs = skuString;
}

// ❌ invalid
else {
  console.warn("Invalid SKU format:", skuString);
  return;
}

  // console.log("Similar SKUs metafield found ", similarSKUs);

  if (!similarSKUs.length) return;

  // 🔥 Build SKU map ONCE
  await buildGlobalSKUMap();

  // 🔥 Fast lookup
  const handles = similarSKUs
    .map(getHandleBySKU)
    .filter(Boolean);

  if (!handles.length) {
    console.warn("No products found from SKUs");
    return;
  }

  await loadSimilarProducts(handles);
});


/***********************
 BUILD SKU MAP (SINGLE SCAN)
************************/
// async function buildSKUMap() {
//   const cached = sessionStorage.getItem("sku_map");

//   if (cached) {
//     skuMap = JSON.parse(cached);
//     console.log("Loaded SKU map from cache:", Object.keys(skuMap).length);
//     return;
//   }

//   console.log("Building SKU map...");

//   const limit = 250;
//   let page = 1;

//   while (true) {
//     console.log(`Fetching products page ${page}`);

//     const res = await fetch(`/collections/all/products.json?limit=${limit}&page=${page}`);
//     const data = await res.json();

//     const products = data.products || [];

//     if (!products.length) break;

//     for (const product of products) {
//       for (const variant of product.variants || []) {
//         if (variant.sku) {
//           skuMap[variant.sku.toLowerCase()] = product.handle;
//         }
//       }
//     }

//     if (products.length < limit) break;

//     page++;
//   }

//   console.log("SKU map ready:", Object.keys(skuMap).length);

//   sessionStorage.setItem("sku_map", JSON.stringify(skuMap));
// }


/***********************
 SKU → HANDLE (FAST ⚡)
************************/
// function getProductHandleBySKU(sku) {
//   return skuMap[sku.toLowerCase()] || null;
// }


/***********************
 LOAD SIMILAR PRODUCTS
************************/
async function loadSimilarProducts(handles) {
  const container = document.querySelector("#avalon-similar-pdt");

  if (!container) {
    console.error("Container not found");
    return;
  }

  // Remove duplicates
  const uniqueHandles = [...new Set(handles)];

  const products = await Promise.all(
    uniqueHandles.map(handle => getProductData(handle))
  );

  let rendered = 0;

  products.forEach(product => {
    if (product) {
      renderSimilarProduct( 'data-similar-container', product, container);
      rendered++;
    }
  });

  if (rendered === 0) return;

  initSimilarSlider('data-similar-container', container);
}


/***********************
 PRODUCT LOADER
************************/
async function getProductData(handle) {
  try {
    const res = await fetch(`/products/${handle}.js`);

    if (!res.ok) throw new Error("Product not found");

    return await res.json();

  } catch (err) {
    console.error("Product error:", handle, err);
    return null;
  }
}


/***********************
 RENDER CARD
************************/
function renderSimilarProduct(containerName, product, container) {
   var compare_at_price_new = product.price / 100;

            var discount = 0;

          // console.log(settings)

            if (settings.discount1_from_price && settings.discount1_to_price && settings.discount1 && compare_at_price_new >= settings.discount1_from_price && compare_at_price_new <= settings.discount1_to_price) {
              discount = settings.discount1;
              // console.log(discount)
            } else if (settings.discount2_from_price && settings.discount2_to_price && settings.discount2 && compare_at_price_new >= settings.discount2_from_price && compare_at_price_new <= settings.discount2_to_price) {
              discount = settings.discount2;
              // console.log(discount)
            } else if (settings.discount3_from_price && settings.discount3_to_price && settings.discount3 && compare_at_price_new >= settings.discount3_from_price && compare_at_price_new <= settings.discount3_to_price) {
              discount = settings.discount3;
              // console.log(discount)
            } else if (settings.discount4_from_price && settings.discount4_to_price && settings.discount4 && compare_at_price_new >= settings.discount4_from_price && compare_at_price_new <= settings.discount4_to_price) {
              discount = settings.discount4;
              // console.log(discount)
            } else if (settings.discount5_from_price && settings.discount5_to_price && settings.discount5 && compare_at_price_new >= settings.discount5_from_price && compare_at_price_new <= settings.discount5_to_price) {
              discount = settings.discount5;
              // console.log(discount)
            }

      
            // Apply discount to the price
            var discount_multiplier = 1 - discount;
            var discounted_price = product.price * discount_multiplier;
          discounted_price =  Shopify.formatMoney(discounted_price, window.money_format);
              
      
       
      
        var relListCotainer = $('['+containerName+']').find('.products-grid');
        // console.log(relListCotainer);
        var productHTML = '',
            price_min = Shopify.formatMoney(product.price_min, window.money_format);
            if(product.compare_at_price_max != 0){
              var price_max = Shopify.formatMoney(product.compare_at_price_max, window.money_format);
            } else {
              var price_max = product.compare_at_price_max;
            }
        arraycontainsturtles = (product.tags.indexOf("call for price") > -1);

        arraycontainsLadiessize = (product.tags.indexOf("Size:LADIES RINGS") > -1);
        arraycontainsMenssize = (product.tags.indexOf("Size:MENS RINGS") > -1);

        var effectImage = product.featured_image;
        if(product.images[3]){
          effectImage = product.images[3];
        }else if(product.images[2]){
          effectImage = product.images[2];
        }

        productHTML += '<div class="grid-item small--one-half medium-up--one-quarter col">';
        productHTML += '<div class="inner product-item" data-product-id="product-'+product.id+'" data-product-id="product-'+product.handle+'">';
        productHTML += '<div class="inner-top">';

        productHTML += '<div class="product-top">';
        productHTML += '<div class="product-image image-swap">';
        productHTML +='<a href="'+product.url+'" class="product-grid-image" data-collections-related="/collections/all?view=related">';
        if (product.featured_image) {

          productHTML += '<picture>';
          productHTML += '<source media="(max-width:767px)" srcset="'+product.featured_image+'">';
          productHTML += '<source media="(min-width:768px)" srcset="'+product.featured_image+'">';
          productHTML += '<img src="'+product.featured_image+'" alt="'+product.featured_image.alt+'" class="images-one">';
          productHTML += '</picture>';

          productHTML += '<span class="images-two">';
          productHTML += '<picture>';
          productHTML += '<source media="(max-width:767px)" srcset="'+effectImage+'">';
          productHTML += '<source media="(min-width:768px)" srcset="'+effectImage+'">';
          productHTML += '<img src="'+effectImage+'" alt="'+product.featured_image.alt+'" >';
          productHTML += '</picture>';
          productHTML += '</span>';
        }
        productHTML += '</a>';
        productHTML += '</div>';

        productHTML += '<div class="product-wishlist abs-center">';
        productHTML += '<a class="wishlist " title="Wishlist" data-icon-wishlist="" href="#" data-product-handle="'+product.handle+'" data-id="'+product.id+'" tabindex="0">';
        productHTML += '<i class="fa fa-heart-o" aria-hidden="true"></i>';
        productHTML += '</a>';

        productHTML += '<a class="quickview-button" href="javascript:void(0)" id="'+product.handle+'" title="Quick View" tabindex="0">'
        productHTML += '<span>';
        productHTML += '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 380.25 380.25" style="fill: #121212;"><path d="M96,339c5,0,9,3,9,8a9,9,0,0,1-9,9H8c-4,0-8-4-8-9V8C0,4,4,0,9,0H201c2,0,4,1,6,2l61,62q3,3,3,6V186c0,4-4,8-9,8-4,0-8-4-8-8V80H201c-5,0-8-4-8-9V17H17V339ZM243,63,209,29V63Z"></path><path d="M132,216a72.43,72.43,0,0,1,102,0c25,26,27,68,5,96l54,54c3,3,3,8,0,12-3,3-9,3-12,0l-54-54c-28,22-69,20-95-6A72.43,72.43,0,0,1,132,216Zm12,12c-22,22-22,57,0,78,21,22,56,22,78,0,21-21,21-56,0-78C200,207,165,207,144,228Z"></path></svg>';
        productHTML += '</span>';
        productHTML += '</a>';

        productHTML += '</div>';

        productHTML += '<div class="product-des abs-center">';
        productHTML += '<div class="action">';
        if (product.price_min == 0) {
          productHTML += '<div> &nbsp; </div>';                      
       // } else if ( product.price_min > priceThreshold ) {
        //  productHTML += '<div> &nbsp; </div>';
        } else if ( arraycontainsturtles ) {
          
        } else {                  
          productHTML += '<form action="/cart/add" method="post" class="variants" id="wishlist-product-form-' + product.id +'" data-id="product-actions-'+product.id+'" enctype="multipart/form-data">';
          if (product.available) {
            if ( arraycontainsLadiessize ){
              productHTML += '<a class="btn" title="'+product.title+'" href="' + product.url +'">'+window.inventory_text.select_options+'</a>';
            }
            else if ( arraycontainsMenssize ){
              productHTML += '<a class="btn" title="'+product.title+'" href="' + product.url +'">'+window.inventory_text.select_options+'</a>';
            }
            else if (product.variants.length == 1) {
              productHTML += '<button data-btn-addToCart class="btn add-to-cart-btn" data-form-id="#wishlist-product-form-' + product.id +'" type="submit">'+window.inventory_text.add_to_cart+'</button><input type="hidden" name="id" value="'+ product.variants[0].id +'" />';
            }
            //if (product.variants.length == 1){
            //    productHTML += '<a class="btn" title="'+product.title+'" href="' + product.url +'">'+window.inventory_text.select_options+'</a>';
            // }
          } else {
            productHTML += '<button class="btn add-to-cart-btn" type="submit" disabled="disabled">'+window.inventory_text.unavailable+'</button>';
          }
          productHTML += '</form>';  
          productHTML += '</div>';
        };

        productHTML += '</div>';

        productHTML += '</div>';

        productHTML += '<div class="product-bottom">';

        productHTML += '<div class="wrapper-compare enable_vendor">';
        productHTML += '<div class="product-vendor">';
        productHTML += '<a href="' + window.router + '/collections/vendors?q='+product.vendor+'" title="'+product.vendor+'">'+product.vendor+'</a>';
        productHTML += '</div>';
        productHTML += '</div>';

        productHTML += '<a class="product-title" href="'+product.url+'" title="'+product.title+'">'+product.title+'</a>';
        productHTML += '<div class="price-box">';
       if(product.compare_at_price == 0){
          productHTML += '<div class="price-regular">';
              if (product.price_min == 0) {
                productHTML += '<span> Call for Price </span>';
      
              } else if ( arraycontainsturtles ) {
                productHTML += '<span> Call for Price </span>';
      
              } else {
                // if (product.price_min > priceThreshold) {
                //     productHTML += `<span> Call for Price </span>`;
                // } else {
                productHTML += '<span> '+ price_min +' </span>'; 
                // }
              };
          productHTML += '</div>';
         } else{  
                 if (discount > 0 && settings.show_sale_price) {
                  productHTML += '<div class="price-sale">';
                  productHTML += '<span class="old-price"> '+ price_min +' </span>';       
                  productHTML += '<span class="special-price"> '+ discounted_price +' </span>';    
                  productHTML += '</div>';
                       
                } else {
                      
                        productHTML += ` <div class="price-sale">
                                        <span id="compare_at_price" class="old-price">${compare_at_price}</span>
                                        <span id="on_sale_price" class="special-price">${price_min}</span>
                                    </div>`;  
                };
                
            }
        productHTML += '</div>';

        productHTML += '</div>';


        productHTML += '</div></div></div>';
        
        relListCotainer.append(productHTML);
        var regex = /(<([^>]+)>)/ig;
        var href = $('.wrapper-wishlist a.share').attr("href");
        href += encodeURIComponent( product.title + '\nPrice: ' + price_min.replace(regex, "") + '\nLink: ' + window.location.protocol + '//' + window.location.hostname + product.url +'\n\n');
        $('.wrapper-wishlist a.share').attr("href", href );     
  // container.insertAdjacentHTML("beforeend", productHTML);
}


/***********************
 SLIDER INIT
************************/
function initSimilarSlider(containerName) {
        var featuredProduct = $('['+containerName+']');

            featuredProduct.each(function () {
              var self = $(this),
                  productGrid = self.find('.products-grid'),
                  gridItemWidth = productGrid.data('row'),
                  hasRightSidebar = $('.halo-product-content .pro-page [data-has-right-sidebar]');

              if(productGrid) {
                  productGrid.slick({
                      get vertical() {
                          if(productGrid.hasClass('verticle') && $('.relate-verticle').length) {
                              return this.vertical = true;
                          }else {
                              return this.vertical = false;
                          }
                      },
                     slidesToScroll: 4,
                     slidesToShow: 4,
                                     
                      speed: 1000,
                      infinite: false,
                      centerMode:false, 
                      get dots() {
                          if(self.hasClass('has-banner')) {
                              return this.dots = true;
                          }else {
                              if(window.product_style == 'supermarket' || window.product_style == 'surfup') {
                                  return this.dots = true;
                              } else {
                                  return this.dots = false;
                              }
                          };
                      },
                      get nextArrow() {
                          if ((window.layout_style == 'layout_style_1170') || (window.layout_style == 'layout_style_flower')) {
                              return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                          } else if ((window.layout_style == 'layout_style_fullwidth') || (window.layout_style == 'layout_style_suppermarket') || (window.layout_style == 'layout_style_surfup')) {
                              return this.nextArrow = '<button type="button" class="slick-next"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                          }
                          else {
                              return this.nextArrow = '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>';
                          }
                      },
                      get prevArrow() {
                          if ((window.layout_style == 'layout_style_1170') || (window.layout_style == 'layout_style_flower')) {
                              return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>';
                          } else if ((window.layout_style == 'layout_style_fullwidth') || (window.layout_style == 'layout_style_suppermarket') || (window.layout_style == 'layout_style_surfup')) {
                              return this.prevArrow = '<button type="button" class="slick-prev"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>';
                          } 
                          else {
                              return this.prevArrow = '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>';
                          }
                      },
					  responsive: [
                              {
                                  breakpoint: 1400,
                                  settings: {
                                      get slidesToShow() {
                                          if(self.hasClass('has-banner')) {
                                              return this.slidesToShow = 3;
                                          }else {
                                              if(gridItemWidth > 5) {
                                                  return this.slidesToShow = 5;
                                              }
                                              else {
                                                  if(window.product_style == 'supermarket' || window.product_style == 'surfup') {
                                                      return this.slidesToShow = 4;
                                                  } else {
                                                      return this.slidesToShow = 4;
                                                  }
                                              }
                                          }
                                      },
                                      get slidesToScroll() {
                                          if (self.hasClass('has-banner')) {
                                              return this.slidesToScroll = 3;
                                          }else {
                                              if(productGrid.hasClass('verticle')) {
                                                  return this.slidesToScroll = 1;
                                              }else {
                                                  if(gridItemWidth >= 4) {
                                                      return this.slidesToScroll = 4;
                                                  }else if(gridItemWidth = 3) {
                                                      return this.slidesToScroll = 3;
                                                  }else {
                                                      return this.slidesToScroll = 2;
                                                  }
                                              }
                                          };
                                      }
                                  }
                              },
                              {
                                  breakpoint: 1200,
                                  settings: {
                                      dots: true,
                                      arrows: false,
                                      vertical: false,
                                      get slidesToShow() {
                                          if(self.hasClass('has-banner')) {
                                              return this.slidesToShow = 2;
                                          }else {
                                              if(gridItemWidth >= 4) {
                                                  return this.slidesToShow = 4;
                                              }else if(gridItemWidth = 3) {
                                                  return this.slidesToShow = 3
                                              }else {
                                                  return this.slidesToShow = 2
                                              }
                                          }
                                      },
                                      get slidesToScroll() {
                                          if (self.hasClass('has-banner')) {
                                              return this.slidesToScroll = 2;
                                          }else {
                                              if(gridItemWidth >= 4) {
                                                  return this.slidesToScroll = 4;
                                              }else if(gridItemWidth = 3) {
                                                  return this.slidesToScroll = 3
                                              }else {
                                                  return this.slidesToScroll = 2
                                              }
                                          };
                                      }
                                  }
                              },
                              {
                                  breakpoint: 992,
                                  settings: {
                                      dots: true,
                                      arrows: false,
                                      vertical: false,
                                      get slidesToShow() {
                                          if(gridItemWidth >= 3) {
                                              return this.slidesToShow = 3;
                                          }else {
                                              return this.slidesToShow = 2
                                          }
                                      },
                                      get slidesToScroll() {
                                          if(gridItemWidth >= 3) {
                                              return this.slidesToScroll = 3;
                                          }else {
                                              return this.slidesToScroll = 2
                                          }
                                      }
                                  }
                              },
                              {
                                  breakpoint: 768,
                                  settings: {
                                      slidesToShow: 2,
                                      slidesToScroll: 2,
                                      arrows: false,
                                      vertical: false,
                                      dots: true
                                  }
                              },
                              {
                                  breakpoint: 575,
                                  settings: {
                                      slidesToShow: 1,
                                      slidesToScroll: 1,
                                      arrows: false,
                                      vertical: false,
                                      dots: true
                                  }
                              }
                          ]
                  });
              };
            });
    };